'use strict';

if (!Array.prototype.filter) {
  Array.prototype.filter = function (fn, ctx) {
    var f = [];
    this.forEach(function (v, i, t) {
      if (fn.call(ctx, v, i, t)) { f.push(v); }
    }, ctx);
    return f;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/rome/src/polyfills/array.filter.js
// module id = 284
// module chunks = 0